export default __webpack_public_path__ + "img/emTiAQGm.8836f374.svg";